import React, { useEffect, useState } from 'react'
import { FaCoins } from 'react-icons/fa'
import utils from '../../utils'
import { useAuth } from '../../context/UserContext'
import adminServices from '../../services/AdminServices'
import { GiReceiveMoney } from "react-icons/gi";
import { FaCalendarDay } from "react-icons/fa6";
import vendorServices from '../../services/VendorSevices'
import paymentsService from '../../services/PaymentServices'

function OrdersStats() {
    const { user } = useAuth()
    const [stats, setStats] = useState()

    useEffect(() => {
        getPaymentStats(user);
    }, [user]);

    const getPaymentStats = (user) => {
        let services;
        if (user?.is_admin) {
            services = adminServices;
        }
        if (user?.is_vendor) {
            services = vendorServices;
        }
        if (!user?.is_admin && !user?.is_vendor) {
            services = paymentsService
        }
        if (services && typeof services.paymentsStats === 'function') {
            services.paymentsStats().then(
                (res) => {
                    setStats(res.data);
                },
                (err) => {
                    console.log(err);
                }
            );
        }
    };
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {(user?.is_admin || user?.is_vendor) ? (
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">
                                {!user?.is_admin && !user?.is_vendor ? 'Expenditure':'Total Revenue'} 
                            </p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.revenue_total || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaCoins className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                ):null}
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Paid Orders</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.paid_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><GiReceiveMoney className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">This Month</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.this_month || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaCalendarDay className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default OrdersStats